import jQuery from 'jquery';

/**
 * Expose this function to allow external google script to access it.
 */
window.googleTranslateElementInit = () => {
  new google.translate.TranslateElement({pageLanguage: 'sv'}, 'googleTranslateElement');
};

export default function ($ = jQuery) {
  const googleTranslateContainer = document.getElementById('googleTranslateContainer');
  const toggleButtons = document.querySelectorAll('.js-toggleGoogleTranslate');

  toggleButtons.forEach(el => el.addEventListener('click', e => {
    e.preventDefault();
    googleTranslateContainer.classList.toggle('d-none');
  }));
}
